export default "__VITE_ASSET__CRg_gMqo__"